module.exports = __webpack_public_path__ + "1343e7b925860db7a589a56d360ea2b5.png";